const PREFIX_PATH = "/Images-videos/"

export default [
  `${PREFIX_PATH}home_01.jpg`,
  `${PREFIX_PATH}home_02.jpg`,
  `${PREFIX_PATH}home_03.jpg`,
  `${PREFIX_PATH}home_04.jpg`,
  `${PREFIX_PATH}home_05.jpg`,
];
